module.exports = __webpack_public_path__ + "img/balanced_strategy_graphics.77bd0fd5.png";